import ApiService from '../service/ApiServiceFetch';
import MethodeService from '../service/MethodService';
import config from '../config.json';

let moduleApi = {};
let moduleName = "";

moduleApi.getPrefillId = (data) => {
    let objData = {
        method: "POST",
        url: config.surveyPath + "prefills/",
        params: {},
        data: data,
        type: "",
        message: {
            success: "",
            error: "",
        },
    };
    return ApiService(objData);
}

moduleApi.getFile = (id) => {
    let objData = {
        method: "GET",
        url: config.surveyPath + "mushroom_files/" + id,
        params: {},
        type: "",
        message: {
            success: "",
            error: ""
        }
    };
    return ApiService(objData);
}
export default moduleApi;